import { useCallback, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { GlobalContextProvider } from "./framework/GlobalContext";
import { isAuthorizedUser } from "./services/login-services";
import Home from "./apps/Home";
import Login from "./login/Login";
import PageNotFound from "./apps/PageNotFound";
import "./App.css";
import "./assets/fonts/OpenSans.ttf";
import useBeforeUnload from "./hooks/useBeforeUnload";

function App() {
  useBeforeUnload((e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.returnValue = "";
  });
  const navigate = useNavigate();
  const isAuthenticated = useCallback(async () => {
    const authenticated = await isAuthorizedUser();
    if (!authenticated) {
      navigate("/login");
      return;
    }
    navigate("/home");
  }, [navigate]);
  useEffect(() => {
    isAuthenticated();
  }, [isAuthenticated]);
  return (
    <GlobalContextProvider>
        <Routes>
          <Route path="/" element={<Navigate replace to="/home" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/notfound" element={<PageNotFound />} />
          <Route path="*" element={<Navigate replace to="/notfound" />} />
        </Routes>
        {/* <DistributorPaymentsReport /> */}
    </GlobalContextProvider>
  );
}

export default App;
